type AryaConfigOptions = {
  GQL_ENDPOINT: string;
  REST_API_URL: string;
  WAGES_API_URL: string;
  ARYA_AGENTS_API_URL: string;
  ARYA_HELP_URL: string;
};

type AryaConfigKeys = 'GQL_ENDPOINT' | 'REST_API_URL' | 'WAGES_API_URL' | 'ARYA_AGENTS_API_URL' | 'ARYA_HELP_URL';

type AryaConfig = {
  local: AryaConfigOptions;
  development: AryaConfigOptions;
  'test-kube': AryaConfigOptions;
  production: AryaConfigOptions;
};

const aryaConfig: AryaConfig = {
  local: {
    GQL_ENDPOINT: 'https://staging.api.aryaworks.com',
    REST_API_URL: 'https://staging2.api.aryaworks.com',
    WAGES_API_URL: 'https://f2jtsty7m2sz7345focthf3asu0lqimm.lambda-url.us-east-2.on.aws',
    ARYA_AGENTS_API_URL: 'https://arya-agentic-api-staging-xfhyxtupgq-uc.a.run.app',
    ARYA_HELP_URL: 'https://arya-digital-assistant.zendesk.com/hc/en-us/sections/44495842548243-Live-Chat',
  },
  development: {
    GQL_ENDPOINT: 'https://staging.api.aryaworks.com',
    REST_API_URL: 'https://dev.api.aryaworks.com',
    WAGES_API_URL: 'https://f2jtsty7m2sz7345focthf3asu0lqimm.lambda-url.us-east-2.on.aws',
    ARYA_AGENTS_API_URL: 'https://arya-agentic-api-staging-xfhyxtupgq-uc.a.run.app',
    ARYA_HELP_URL: 'https://arya-digital-assistant.zendesk.com/hc/en-us/sections/44495842548243-Live-Chat',
  },
  'test-kube': {
    GQL_ENDPOINT: 'https://staging.api.aryaworks.com',
    REST_API_URL: 'https://staging3.api.aryaworks.com',
    WAGES_API_URL: 'https://f2jtsty7m2sz7345focthf3asu0lqimm.lambda-url.us-east-2.on.aws',
    ARYA_AGENTS_API_URL: 'https://arya-agentic-api-staging-xfhyxtupgq-uc.a.run.app',
    ARYA_HELP_URL: 'https://arya-digital-assistant.zendesk.com/hc/en-us/sections/44495842548243-Live-Chat',
  },
  production: {
    GQL_ENDPOINT: 'https://api.aryaworks.com',
    REST_API_URL: 'https://prod.api.aryaworks.com',
    WAGES_API_URL: 'https://pdh4pispcga5nhxv3qokmnj7ny0dzqhq.lambda-url.us-east-2.on.aws',
    ARYA_AGENTS_API_URL: 'https://arya-agentic-api-xfhyxtupgq-uc.a.run.app',
    ARYA_HELP_URL: 'https://arya-digital-assistant.zendesk.com/hc/en-us/sections/44495842548243-Live-Chat',
  },
};

export default function getAryaConfig(key: AryaConfigKeys) {
  if (
    // If ARYA_PLATFORM is not defined
    !process.env.ARYA_PLATFORM ||
    // Or if ARYA_PLATFORM is not equal to local, development, test-kube, or production
    (process.env.ARYA_PLATFORM !== 'local' &&
      process.env.ARYA_PLATFORM !== 'development' &&
      process.env.ARYA_PLATFORM !== 'test-kube' &&
      process.env.ARYA_PLATFORM !== 'production')
  ) {
    throw new Error(`ARYA_PLATFORM must be defined as "local", "development", "test-kube" or "production"`);
  }
  return aryaConfig[process.env.ARYA_PLATFORM][key];
}
